import { SparklesIcon } from "@heroicons/react/24/solid";

// Floating shortcut to the Smart Note flow — same entry point as the spacebar. Hides itself
// while the modal is open (and sits behind the modal's backdrop regardless).
export default function SmartNoteFab({ onClick, hidden = false }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Ontik Intelligence"
      title="Ontik Intelligence · Space"
      className={`fixed bottom-6 right-6 z-40 flex items-center gap-2.5 rounded-full bg-gradient-to-br from-violet-600 via-indigo-600 to-blue-600 py-3 pl-4 pr-5 text-white shadow-lg shadow-indigo-500/40 transition-all duration-200 hover:scale-[1.03] hover:shadow-xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white ${
        hidden ? "pointer-events-none translate-y-2 opacity-0" : "opacity-100"
      }`}
    >
      <SparklesIcon aria-hidden="true" className="size-5" />
      <span className="text-sm font-semibold">Ontik Intelligence</span>
    </button>
  );
}
